import { render, staticRenderFns } from "./ExportBookingCompensation.vue?vue&type=template&id=4070c69c&"
import script from "./ExportBookingCompensation.vue?vue&type=script&lang=ts&"
export * from "./ExportBookingCompensation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports